// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import ScrollSwapController from "./scroll_swap_controller"
application.register("scroll-swap", ScrollSwapController)

import StickyPhoneController from "./sticky_phone_controller"
application.register("sticky-phone", StickyPhoneController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import VideoHeroController from "./video_hero_controller"
application.register("video-hero", VideoHeroController)
